<template>
  <button
    type="button"
    class="fortune-fab"
    :style="{ bottom: bottomOffset }"
    aria-label="Скидки для клиентов"
    @click="goToFortune"
  >
    <img
      src="@/assets/icons/fortune.png"
      alt=""
      class="fortune-fab__icon"
      loading="lazy"
    />
  </button>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'FortuneFab',
  setup() {
    const router = useRouter()
    const showScrollUp = ref(false)

    function onScroll() {
      showScrollUp.value = window.scrollY > 200
    }

    function goToFortune() {
      router.push({ name: 'fortune' })
    }

    const bottomOffset = computed(() => {
      // если стрелки нет — сидим на обычном отступе
      // если стрелка есть (OrderButton снизу) — поднимаем колесо выше неё
      return showScrollUp.value ? '96px' : '24px'
    })

    onMounted(() => {
      window.addEventListener('scroll', onScroll, { passive: true })
      onScroll()
    })

    onUnmounted(() => {
      window.removeEventListener('scroll', onScroll)
    })

    return {
      bottomOffset,
      goToFortune,
    }
  },
}
</script>

<style scoped lang="scss">
@import "../styles/_variables.scss";

.fortune-fab {
  position: fixed;
  right: 24px;
  z-index: 95;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: radial-gradient(circle at 30% 30%, #4b5563, #020617);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  transition:
    transform 0.18s ease-out,
    box-shadow 0.18s ease-out,
    opacity 0.18s ease-out,
    bottom 0.22s ease-out;

  &:hover {
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.6);
  }

  &:active {
    transform: translateY(0) scale(0.98);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.6);
  }

  &__icon {
    width: 32px;
    height: 32px;
    object-fit: contain;
    display: block;
  }

  @media (max-width: $breakpoint-mobile) {
    right: 16px;
    width: 48px;
    height: 48px;

    &__icon {
      width: 28px;
      height: 28px;
    }
  }
}
</style>

